export default __webpack_public_path__ + "bbe2ce18b63335b3c3e146ae0ecd53e2.png";